/**
 * Sentry browser error tracking, enabled in production only.
 *
 * The DSN is a public client key — it can only ingest events, so it is safe to
 * ship in the bundle. The release comes from a meta tag rendered by the Rails
 * layout (KAMAL_VERSION, shared with the backend Sentry config).
 */

import * as Sentry from '@sentry/react';

import { IGNORED_ERROR_PATTERNS, shouldIgnoreSentryEvent } from '@/lib/sentryFilters';

const SENTRY_DSN = 'https://bf4ecc733a18f3be4165678c6d9d2ea8@o4510747740667904.ingest.de.sentry.io/4511551743524944';

export function initSentry(): void {
  // Production redirects all hosts to the canonical www.kali.care.
  if (window.location.hostname !== 'www.kali.care') return;

  Sentry.init({
    dsn: SENTRY_DSN,
    release: document.querySelector<HTMLMetaElement>('meta[name="sentry-release"]')?.content,
    environment: 'production',

    // Never attach IP addresses or other default PII.
    sendDefaultPii: false,

    // Only report errors originating from our own bundle (skips browser extensions).
    allowUrls: [/https:\/\/(www|app)\.kali\.care/],

    // Client connectivity noise from dropped or cancelled requests (e.g. flaky
    // mobile networks during chat polling) and stale assets after deploys.
    ignoreErrors: IGNORED_ERROR_PATTERNS,

    beforeSend(event) {
      return shouldIgnoreSentryEvent(event) ? null : event;
    },
  });
}
